import { render } from "./modal-dettaglio-notifica.vue?vue&type=template&id=23e380f3&scoped=true"
import script from "./modal-dettaglio-notifica.vue?vue&type=script&lang=js"
export * from "./modal-dettaglio-notifica.vue?vue&type=script&lang=js"

import "./modal-dettaglio-notifica.vue?vue&type=style&index=0&id=23e380f3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e380f3"]])

export default __exports__